module.exports = __webpack_public_path__ + "static/alarm.336f74a4.svg";